module.exports = __webpack_public_path__ + "static/media/aaron-burson-242135-unsplash.e3e92e41.jpg";